import dynamicallyLoadLib from './dynamicallyLoadLib';

export const utils = {
  dynamicallyLoadLib: dynamicallyLoadLib,
};
